document.addEventListener('DOMContentLoaded', () => {
    // 全てのfacet-remove-search要素を取得
    const facetRemoves = document.querySelectorAll('facet-remove-search');

    // 各要素にイベントリスナーを設定
    facetRemoves.forEach(facetRemove => {
        facetRemove.addEventListener('click', (event) => {
            // デフォルトのリンクの挙動を防ぐ
            event.preventDefault();

            // ここに実行したい処理を書きます
            console.log('facet-remove-search がクリックされました(変更処理)');

            // 親要素の.parent-displayを見つける
            const parentDisplay = facetRemove.closest('.parent-display');

            if (parentDisplay) {
                // その親要素内のfieldsetにあるチェックボックスを全て取得
                const checkboxes = parentDisplay.querySelectorAll('fieldset input[type="checkbox"]');

                // 全てのチェックボックスのチェックを外す
                checkboxes.forEach(checkbox => {
                    checkbox.checked = false;
                });

                // 選択数を更新
                const selectedCounter = parentDisplay.querySelector('.facets__selected');
                if (selectedCounter) {
                    selectedCounter.textContent = "0 selected";
                }
            }

            /*
            // 例：クリックされた要素内のリンクのURLに遷移する場合
            const link = facetRemove.querySelector('a');
            if (link) {
                window.location.href = link.getAttribute('href');
            }
             */

        });
    });


    // チェックボックスの変更検知
    const allCheckboxes = document.querySelectorAll('fieldset input[type="checkbox"]');

    allCheckboxes.forEach(checkbox => {
        checkbox.addEventListener('change', (event) => {
            // 親のparent-displayを取得
            const parentDisplay = event.target.closest('.parent-display');

            if (parentDisplay) {
                // 同じparent-display内の全てのチェック済みボックスを取得
                const checkedBoxes = parentDisplay.querySelectorAll('fieldset input[type="checkbox"]:checked');

                // 選択数を更新
                const selectedCounter = parentDisplay.querySelector('.facets__selected');
                if (selectedCounter) {
                    selectedCounter.textContent = `${checkedBoxes.length} selected`;
                }
            }
        });
    });

});